import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import CancelButton from '../atoms/CancelButton';
import ChangeButton from '../atoms/ChangeButton';

const styles = {};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    openAdd,
    updateOpenAdd,
    cancelAction,
    addAction,
    disableStatus
  }) => {
    return (
      <Dialog
        open={openAdd}
        onClose={() => {
          updateOpenAdd(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography component="p" className={classes.description}>
            このメニューをこどもごちめしに登録しますか？
          </Typography>
        </DialogContent>
        <DialogActions>
          <CancelButton
            onClickAction={cancelAction}
            color="default"
            btnText="いいえ"
          />
          <ChangeButton
            onClickAction={addAction}
            enabled={!disableStatus}
            btnText="はい"
          />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
